// MultiStep.tsx
import React from 'react';
import ClayMultiStepNav from '@clayui/multi-step-nav';
import "./MultiStep.css";

interface StepConfig {
  key: string;
  subTitle: string;
  clickable?: boolean;
}

interface Props {
  step: number;
  setStep: (stepIndex: number) => void;
  steps: StepConfig[];
}

const MultiStep: React.FC<Props> = ({ step, setStep, steps }) => {
  return (
    <ClayMultiStepNav className="custom_multistep">
      {steps.map((item, index) => {
        const active = step === index;
        const complete = step > index;

        return (
          <ClayMultiStepNav.Item
            key={item.key}
            active={active}
            complete={complete}
            expand={index + 1 !== steps.length}
          >
            <ClayMultiStepNav.Divider />

            <ClayMultiStepNav.Indicator
              label={index + 1}
              complete={complete}
              subTitle={item.subTitle}
              onClick={() => {
                if (item.clickable && step > index) {
                  setStep(index);
                }
              }}
            />
          </ClayMultiStepNav.Item>
        );
      })}
    </ClayMultiStepNav>
  );
};

export default MultiStep;
